"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Jun 12 2018
 */

var big_decimal_1 = require("@logio/big-decimal");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var moment = require("moment");

var DataDictionaryError_1 = require("../model/data-dictionary/DataDictionaryError");

var DateParser_1 = require("../model/data-dictionary/parsers/DateParser");

var MomentProvider_1 = require("../moment/MomentProvider");

var utils_1 = require("../utils");

var DataObjectConversions_1 = require("./DataObjectConversions");
/**
 * Implementation of DataObjectConversions for general JSON representation.
 *
 * @author JMe
 */


var JSONDataObjectConversions =
/*#__PURE__*/
function (_DataObjectConversion) {
  _inherits(JSONDataObjectConversions, _DataObjectConversion);

  function JSONDataObjectConversions() {
    _classCallCheck(this, JSONDataObjectConversions);

    return _possibleConstructorReturn(this, _getPrototypeOf(JSONDataObjectConversions).apply(this, arguments));
  }

  _createClass(JSONDataObjectConversions, [{
    key: "toBigNumber",

    /**
     * @inheritDoc
     */
    value: function toBigNumber(value) {
      if (!utils_1.Utils.isString(value) && !utils_1.Utils.isNumber(value)) {
        throw new DataDictionaryError_1.DataDictionaryError("Wrong value passed into toBigNumber: ".concat(JSON.stringify(value)));
      }

      return big_decimal_1.bigdecimal(value);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "fromBigNumber",
    value: function fromBigNumber(value) {
      if (!utils_1.Utils.isObject(value) || value === null) {
        throw new DataDictionaryError_1.DataDictionaryError('Value must be object');
      }

      return value.toString();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDate",
    value: function toDate(value) {
      if (!value) {
        throw new DataDictionaryError_1.DataDictionaryError("Unset date ".concat(value, " not allowed"));
      } // FIXME common-be-fe tests does not support IOC


      return typescript_ioc_1.Container.isBound(MomentProvider_1.MomentProvider) ? typescript_ioc_1.Container.get(MomentProvider_1.MomentProvider).fromString(value, DateParser_1.DateParser.ISO_PATTERN).instance : moment(value, DateParser_1.DateParser.ISO_PATTERN, true);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "fromDate",
    value: function fromDate(value) {
      if (typeof value !== 'object' || value === null) {
        throw new DataDictionaryError_1.DataDictionaryError('Value must be object');
      }

      return value.toISOString();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "classToDocumentId",
    value: function classToDocumentId(document) {
      if (!document) {
        return null;
      }

      return {
        id: document.id
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "documentToClassId",
    value: function documentToClassId(document) {
      if (!document) {
        throw new DataDictionaryError_1.DataDictionaryError("Unset document ".concat(document, " when converting to class id not allowed"));
      }

      return document.id || utils_1.Utils.VOID_ID;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toClassReferenceId",
    value: function toClassReferenceId(value) {
      if (utils_1.Utils.isUndefined(value)) {
        return null;
      }

      return utils_1.Utils.isObject(value) ? value.toString() : value;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocumentReferenceId",
    value: function toDocumentReferenceId(value) {
      return value;
    }
  }]);

  return JSONDataObjectConversions;
}(DataObjectConversions_1.DataObjectConversions);

var jsonConversions = new JSONDataObjectConversions();
exports.jsonConversions = jsonConversions;